export function getValues(a) {
  return Array.isArray(a) ? a : Array.isArray(a && a.values) ? a.values : [];
}
